import { render } from "../templates/order-info.html?vue&type=template&id=283c4487&scoped=true"
import script from "./OrderInfo.vue?vue&type=script&lang=js"
export * from "./OrderInfo.vue?vue&type=script&lang=js"

import "./OrderInfo.vue?vue&type=style&index=0&id=283c4487&lang=scss&scoped=true"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-283c4487"]])

export default __exports__